import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import styles from './index.css';

const ColumnTitle = errorBoundary(
    class extends PureComponent {
        static propTypes = {
            title: PropTypes.string,
        };

        render() {
            const { title } = this.props;

            return <div className={styles.box_right_title}>{title}</div>;
        }
    },
);

export { ColumnTitle };
export default ColumnTitle;
